/**
 * Joins an array into a single string. It removes empty values and trims the
 * values before joining them. Nested arrays are also joined.
 *
 * @example
 * join(['foo ', ' bar', [123, -123, [NaN]], null, undefined, '', ' ', ' baz ']); // 'foo, bar, 123, -123, baz'
 *
 * @param {Array<unknown>} values Array of values to be joined together
 * @param {string} [separator=", "] Separator to be used between the values. Default is `', '`.
 * @returns {string} Joined string
 */
export function join(values, separator = ', ') {
  if (!Array.isArray(values)) {
    return '';
  }
  return values.filter(value => value != null && !Number.isNaN(value)).map(value => Array.isArray(value) ? join(value, separator) : String(value).trim()).filter(value => value !== '').join(separator);
}
//# sourceMappingURL=join.js.map